// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__16QpN","header":"PatientQuestionnaire_header__20OJo","info":"PatientQuestionnaire_info__mQuyX"};